import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { Participant } from '../models/participant';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class ParticipantService {
  private participantApiUrl: string;
  constructor(public http: Http, private appServices: AppSettings) {
    this.participantApiUrl = this.appServices.DB_API_ENDPOINT + 'participants/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public addParticipant(newParticipant: Participant): Promise<any> {
    return this.http.post(this.participantApiUrl, newParticipant, this.appServices.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public delParticipant(id): Observable<any> {
    return this.http.delete(this.participantApiUrl + id, this.appServices.apiOptions);
  }

  public editParticipant(participant) {
    return this.http.put(this.participantApiUrl + participant._id, participant, this.appServices.apiOptions);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/participant.service.ts